<template>
    <component :is="tag" :class="rootClasses">
        <slot />
    </component>
</template>

<script>
/**
 * Mirrors Giant_discovery atoms/typography (tag, tagStyle, weight, fontStyle).
 * Tokens: Styles/Variables/_general.scss; mixins: Styles/Mixins/_typography.scss.
 * Styles: Components/_Typography_DiscoverMode.scss.
 */
const allowedTags = ['p', 'span', 'div', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'small', 'label', 'a', 'li', 'blockquote', 'button'];

const allowedStyles = [
    'actionSmall',
    'actionMedium',
    'actionLarge',
    'bodyXSmall',
    'bodySmall',
    'bodyMedium',
    'bodyLarge',
    'bodyXLarge',
    'headlineSmall',
    'headlineMedium',
    'headlineLarge',
    'displayXSmall',
    'displaySmall',
    'displayMedium',
    'displayLarge',
    'displayXLarge',
    'displayXXLarge',
];

/** Matches discovery TypographyProps.weight */
const allowedWeights = ['bold', 'semiBold', 'heavy'];

const weightToClass = {
    bold: 'typography-discover--isBold',
    semiBold: 'typography-discover--isSemibold',
    heavy: 'typography-discover--isHeavy',
};

export default {
    name: 'TypographyDiscoverMode',
    props: {
        tag: {
            type: String,
            default: 'p',
            validator: (v) => allowedTags.includes(v),
        },
        tagStyle: {
            type: String,
            default: 'bodySmall',
            validator: (v) => allowedStyles.includes(v),
        },
        /** bold | semiBold | heavy — same combinations as discovery typography.module.scss */
        weight: {
            type: String,
            default: null,
            validator: (v) => v == null || allowedWeights.includes(v),
        },
        /** italic — allowed on bodySmall / bodyLarge per discovery */
        fontStyle: {
            type: String,
            default: null,
            validator: (v) => v == null || v === 'italic',
        },
    },
    computed: {
        rootClasses() {
            const classes = [
                'typography-discover',
                `typography-discover--${this.tagStyle}`,
            ];
            if (this.weight) {
                classes.push(weightToClass[this.weight]);
            }
            if (this.fontStyle === 'italic') {
                classes.push('typography-discover--isItalic');
            }
            return classes;
        },
    },
};
</script>
